import type { ReactNode } from 'react';
import '../accounting/accounting.css';
import './reagentprep.css';
import { FormTitle } from '../../components/FormTitle';
import { ViewToggle } from '../../components/ViewToggle';

// ─────────────────────────────────────────────────────────────────────────────
// The page frame the three Reagent Preparation lists share (Department layout,
// 2026-11-03): breadcrumb → [List View | Detail View] + FormTitle → the form's
// action toolbar → ONE white grid card. The grid keeps its own Export + Maximize
// icons. The Search box sits IN the toolbar after Export to, as G5 draws it
// (owner request 2026-11-03) — the shared <GridSearch variant="toolbar">.
// ─────────────────────────────────────────────────────────────────────────────

interface Props {
  /** Nav id — FormTitle takes its caption, icon and colour from it. */
  pageId: string;
  /** Last breadcrumb segment (the form's caption). */
  caption: string;
  auditFormName: string;
  loadMs: number | null;
  loading: boolean;
  onHome?: () => void;
  /** The List / Detail switch — only for a list that HAS a detail view. */
  viewToggle?: { onDetail: () => void; disabled: boolean };
  /** The form's <AppToolbar>. */
  toolbar: ReactNode;
  /** The <AppDataGrid>. */
  children: ReactNode;
}

export function ReagentListShell({
  pageId, caption, auditFormName, loadMs, loading, onHome, viewToggle, toolbar, children,
}: Props) {
  return (
    <div className="acc-page">
      <div className="acc-top">
        <div className="acc-bc">
          <a onClick={onHome}>Home</a><i className="ti ti-chevron-right" />
          <span>Reagent Preparation</span><i className="ti ti-chevron-right" />
          <span style={{ color: '#4a3728', fontWeight: 600 }}>{caption}</span>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginTop: 6 }}>
          {viewToggle && (
            <ViewToggle view="list" detailDisabled={viewToggle.disabled}
                        onChange={(v) => { if (v === 'detail') viewToggle.onDetail(); }} />
          )}
          <FormTitle pageId={pageId} loadMs={loadMs} loading={loading} auditFormName={auditFormName} />
        </div>
      </div>
      <div className="acc-body acc-search-tight">
        {toolbar}
        <div className="acc-card">{children}</div>
      </div>
    </div>
  );
}
